'use client'

import React from 'react'
import TokenCardList from '@components/TokenCardList'

const TreasuryTokens = () => {
  return (
    <section className="pt-4">
      <TokenCardList />
    </section>
  )
}

export default TreasuryTokens
